export interface DataBroadcastModel {
  name: string;
  args: any[];
}

export enum DataBroadcast {
  API_REFRESH = 'apiRefresh',
  TENANT_CHANGED = 'tenantChanged',
  SITE_CHANGED = 'siteChanged',
  TRACKER_SITE_CHANGED = 'trackerSiteChanged',
  TRACKER_ENTITY_LOCATION_CHANGED = 'trackerEntityLocationChanged',
  DIALOG_BROADCAST = 'dialog-action',
  DATETIMERANGEAPPLIED = 'dateTimeRangeApplied',
  ENTITYLISTDATETIMEAPPLIED = 'entitiesListingdateApplied',
  TABLE_OPEN = 'tableDrawerOpen',
  PAGE_CONTROL_DATE_CHANGE = 'pageControlDateChange',
  SELECTED_DATE_RANGE = 'selectedDateRange',
  FLOOR_ZONE = 'floorZone',
}
